import { createSlice } from "@reduxjs/toolkit"

export const BrandsSlice = createSlice({
	name: "brands",
	initialState: {
		brands: [],
		errors: [],
	},

	reducers: {
		getBrands: (state, action) => {
			state.brands = action.payload
		},
		getBrandsSuccess: (state, action) => {
			state.brands = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const {getBrands, getBrandsSuccess, getErrors} = BrandsSlice.actions

export default BrandsSlice.reducer
